import { api } from "../lib/api";
import type { BankTransaction } from "./transaction";

export interface TransferSuggestion {
  transaction_a_id: string;
  transaction_a_date: string;
  transaction_a_description: string;
  transaction_a_amount: string;
  transaction_a_account_name: string;
  transaction_b_id: string;
  transaction_b_date: string;
  transaction_b_description: string;
  transaction_b_amount: string;
  transaction_b_account_name: string;
  day_gap: number;
  score: number;
  reason: string;
}

export interface AcceptTransferResult {
  transaction_a: BankTransaction;
  transaction_b: BankTransaction;
}

export function listTransferSuggestions(): Promise<TransferSuggestion[]> {
  return api.get<TransferSuggestion[]>("/api/transfers/suggestions");
}

export function acceptTransfer(
  transactionIdA: string,
  transactionIdB: string,
): Promise<AcceptTransferResult> {
  return api.post<AcceptTransferResult>("/api/transfers/accept", {
    transaction_id_a: transactionIdA,
    transaction_id_b: transactionIdB,
  });
}
